module.exports = __webpack_public_path__ + "img/DocumentsInactive.fa15141f.svg";